var _g, _g2, _path, _path2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuNarc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "NARC",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.728,
    height: 24,
    viewBox: "0 0 32.728 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_53254",
    "data-name": "Group 53254",
    transform: "translate(9.273 0.545)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_780",
    "data-name": "Ellipse 780",
    cx: 2.691,
    cy: 2.747,
    rx: 2.691,
    ry: 2.747,
    transform: "translate(4.4 0.008)",
    fill: "#ffc931"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24669",
    "data-name": "Path 24669",
    d: "M143.091,20.545l1.636,6.545h2.727l-1.636-7.636V15.636h1.091a3.26,3.26,0,0,0,1.355-.3c-.061-.04-.119-.082-.183-.118.064.036.123.078.183.118a3.27,3.27,0,0,0,1.918-2.977V8H148v4.364a1.091,1.091,0,0,1-1.091,1.091h-7.636a1.091,1.091,0,0,1-1.091-1.091V8H136v4.364a3.273,3.273,0,0,0,3.273,3.273h1.091v3.818l-1.636,7.636h2.727Z",
    transform: "translate(-136 -8)",
    fill: "#c00096"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_53255",
    "data-name": "Group 53255",
    transform: "translate(0.553 0.553)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_781",
    "data-name": "Ellipse 781",
    cx: 3.252,
    cy: 3.252,
    r: 3.252,
    transform: "translate(0 0)",
    fill: "#ffc931"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_782",
    "data-name": "Ellipse 782",
    cx: 3.252,
    cy: 3.252,
    r: 3.252,
    transform: "translate(25.117 16.371)",
    fill: "#ffc931"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24672",
    "data-name": "Path 24672",
    d: "M8.077,203.818h9.147a3.27,3.27,0,0,0-5.915-2.405,2.162,2.162,0,0,0-3.232,2.405Z",
    transform: "translate(-7.455 -186.364)",
    fill: "#c9f4f3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24673",
    "data-name": "Path 24673",
    d: "M281.091,123.062c1.667.309,3,.387,4.289-.853.842-.812,1.743-2.716,2.866-3.1a2.634,2.634,0,0,1-2.57-.766,10.047,10.047,0,0,1-1.574-2.33,5.323,5.323,0,0,0-1.838-2.1l-.627.415H280v3.818Z",
    transform: "translate(-260.909 -106.153)",
    fill: "#285caa"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_53256",
    "data-name": "Group 53256",
    transform: "translate(14.26 0.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24676",
    "data-name": "Path 24676",
    d: "M244.831,10.727C244.831,9.221,242.668,8,240,8v5.455C242.668,13.455,244.831,12.233,244.831,10.727Z",
    transform: "translate(-240 -8)",
    fill: "#ffd9b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24677",
    "data-name": "Path 24677",
    d: "M241.636,27.091h2.727l-1.636-7.636V15.636h1.091a3.28,3.28,0,0,0,3.273-3.273V8h-2.182v4.364a1.091,1.091,0,0,1-1.091,1.091H240v7.091Z",
    transform: "translate(-237.896 -8)",
    fill: "#ce07a3"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_53257",
    "data-name": "Group 53257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24678",
    "data-name": "Path 24678",
    d: "M90.8,19.291a.546.546,0,0,0-.422-.2h-.1l-.326-1.522a7.577,7.577,0,0,0,1.029.08,4.049,4.049,0,0,0,2.978-1.2,9.273,9.273,0,0,0,.993-1.238c.521-.724,1.111-1.545,1.669-1.736h0a.545.545,0,1,0-.351-1.033h0A2.119,2.119,0,0,1,94.25,11.8,7.748,7.748,0,0,1,92.985,9.97l-.215-.38a7.756,7.756,0,0,0-1.191-1.636A3.809,3.809,0,0,0,93.1,4.909V.545A.545.545,0,0,0,92.559,0H90.377a.545.545,0,0,0-.545.545V4.909a.546.546,0,0,1-.545.545H87.9a3.273,3.273,0,1,0-4.865,0H81.649a.546.546,0,0,1-.545-.545V.545A.545.545,0,0,0,80.559,0H78.377a.545.545,0,0,0-.545.545V4.909a3.823,3.823,0,0,0,3.818,3.818h.545v3.215l-1.532,7.148h-.1a.546.546,0,0,0-.422.2Zm1.025-9.155.211.371a8.687,8.687,0,0,0,1.457,2.079,3.829,3.829,0,0,0,1.423.873c-.3.344-.579.733-.854,1.115a8.721,8.721,0,0,1-.864,1.089c-.974.938-1.97,1.014-3.5.761l-.961-4.483V8.727h.545A3.793,3.793,0,0,0,90.562,8.5,5.784,5.784,0,0,1,91.823,10.135ZM83.286,3.273a2.182,2.182,0,1,1,2.182,2.182A2.184,2.184,0,0,1,83.286,3.273Zm-.012,8.842A.541.541,0,0,0,83.286,12V8.182a.545.545,0,0,0-.545-.545H81.649a2.73,2.73,0,0,1-2.727-2.727V1.091h1.091V4.909a1.638,1.638,0,0,0,1.636,1.636h7.636a1.638,1.638,0,0,0,1.636-1.636V1.091h1.091V4.909a2.73,2.73,0,0,1-2.727,2.727H88.195a.545.545,0,0,0-.545.545V12a.54.54,0,0,0,.012.115l1.5,6.976H87.53L86,12.959a.545.545,0,0,0-1.058,0l-1.533,6.132H81.779Zm3.131,6.976H84.53l.938-3.751Z",
    transform: "translate(-69.104)",
    fill: "#2a0e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24679",
    "data-name": "Path 24679",
    d: "M3.273,7.091a.545.545,0,1,0,1.091,0A2.73,2.73,0,0,1,7.091,4.364a.545.545,0,1,0,0-1.091A2.73,2.73,0,0,1,4.364.545a.545.545,0,0,0-1.091,0A2.73,2.73,0,0,1,.545,3.273a.545.545,0,0,0,0,1.091A2.73,2.73,0,0,1,3.273,7.091Zm.545-4.58A3.854,3.854,0,0,0,5.126,3.818,3.854,3.854,0,0,0,3.818,5.126,3.854,3.854,0,0,0,2.511,3.818,3.854,3.854,0,0,0,3.818,2.511Z",
    fill: "#2a0e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24680",
    "data-name": "Path 24680",
    d: "M375.091,243.273a2.73,2.73,0,0,1-2.727-2.727.545.545,0,1,0-1.091,0,2.73,2.73,0,0,1-2.727,2.727.545.545,0,1,0,0,1.091,2.73,2.73,0,0,1,2.727,2.727.545.545,0,1,0,1.091,0,2.73,2.73,0,0,1,2.727-2.727.545.545,0,1,0,0-1.091Zm-3.273,1.853a3.849,3.849,0,0,0-1.307-1.307,3.849,3.849,0,0,0,1.307-1.307,3.849,3.849,0,0,0,1.307,1.307A3.854,3.854,0,0,0,371.818,245.126Z",
    transform: "translate(-342.909 -223.636)",
    fill: "#2a0e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24681",
    "data-name": "Path 24681",
    d: "M.623,196.909H9.769a.546.546,0,0,0,.538-.455A3.815,3.815,0,0,0,3.7,193.276a2.676,2.676,0,0,0-.971-.185A2.73,2.73,0,0,0,0,195.818a2.7,2.7,0,0,0,.095.683A.545.545,0,0,0,.623,196.909Zm2.1-2.727a1.612,1.612,0,0,1,.844.243.545.545,0,0,0,.731-.155,2.726,2.726,0,0,1,4.97,1.549H1.091A1.638,1.638,0,0,1,2.727,194.182Z",
    transform: "translate(0 -178.909)",
    fill: "#2a0e54"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2901",
    "data-name": "Rectangle 2901",
    width: 11.662,
    height: 0.449,
    rx: 0.224,
    transform: "translate(10.533 19.167)",
    fill: "#2a0e54"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuNarc);
export default __webpack_public_path__ + "static/media/menu-narc.06a79674a4ad7b04111d197f73a731c8.svg";
export { ForwardRef as ReactComponent };